<router-outlet></router-outlet>
<!-- <div style="position: relative"> -->
  <!-- <ngx-ui-loader></ngx-ui-loader> -->
  <!-- <ngx-shimmer-loading [shape]="'square'" [width]="'90%'"></ngx-shimmer-loading> -->
  <!-- <ngx-skeleton-loader count="20" appearance="line"  ></ngx-skeleton-loader> -->
<!-- </div> -->
